import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import { setSoftLeadEvent } from '../../store/actions/dataLayer';
import Link from '../SEO/Link';
import './styles.css';
import { getMessages } from '../../tppServices/translations/messages';

const ImmersiveTourButton = (props) => {
  const handleClick = () => {
    props.setSoftLeadEvent('immersive tour');
    props.onClick();
  };

  const {
    carouselLayout,
    intl: { formatMessage: t }
  } = props;
  const messages = getMessages();
  return (
    <div
      className={classnames('immersive-action', {
        'carousel-layout': carouselLayout
      })}
    >
      <Link className="immersive-button" onClick={handleClick}>
        {t(messages.immersiveTour)}
      </Link>
    </div>
  );
};

ImmersiveTourButton.defaultProps = {
  carouselLayout: false
};

ImmersiveTourButton.propTypes = {
  /** Tracking */
  addLead: PropTypes.func,
  /** Sets the layout for the BDP */
  carouselLayout: PropTypes.bool,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired
  }).isRequired,
  onClick: PropTypes.func.isRequired,
  setSoftLeadEvent: PropTypes.func.isRequired
};

export default connect(null, (dispatch) =>
  bindActionCreators(
    {
      setSoftLeadEvent
    },
    dispatch
  )
)(injectIntl(ImmersiveTourButton));
